import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { connectedServices } from "../../rbac-consts";
import { default as ClientConnectedServicesContainer } from "./client/ConnectedServicesContainer";

const ConnectedServicesWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={connectedServices.USER}
      yes={() => (
        <ClientConnectedServicesContainer />
      )}
    />
  );
};

export default ConnectedServicesWrapper;